export default {
  join: {
    name: 'join',
    code: 1,
    title: 'modals.error.join.title',
    message: 'modals.error.join.body',
    linkText: 'modals.error.join.linkText',
    linkUrl: 'https://link.gotowebinar.com/plogin'
  },
  poll: {
    name: 'poll',
    code: 2,
    title: 'modals.error.poll.title',
    message: 'modals.error.poll.body'
  },
  video: {
    name: 'video',
    code: 3,
    title: 'modals.error.video.title',
    message: 'modals.error.video.body'
  },
  desktopBrowser: {
    name: 'desktopBrowser',
    group: 'browser-unsupported',
    code: 4,
    title: 'modals.error.desktopBrowser.title',
    message: 'modals.error.desktopBrowser.body',
    footerCopyPasteLink: 'modals.error.desktopBrowser.footerCopyPasteLink',
    footer: 'modals.error.desktopBrowser.footer'
  },
  androidChrome: {
    name: 'androidChrome',
    group: 'browser-unsupported',
    code: 6,
    title: 'modals.error.androidChrome.title',
    message: 'modals.error.androidChrome.body',
    footer: 'modals.error.androidChrome.footer'
  },
  sessionFull: {
    name: 'sessionFull',
    code: 7,
    title: 'modals.error.sessionFull.title',
    message: 'modals.error.sessionFull.body'
  },
  g2sRecordingUnavailable: {
    name: 'g2sRecordingUnavailable',
    code: 8,
    title: 'registration.form.error.g2sRecordingUnavailable.title'
  },
  g2sRecordingError: {
    name: 'g2sRecordingError',
    code: 9,
    title: 'registration.form.error.unknown.title'
  }
};
